import { render } from "./ConvexObjectPage.vue?vue&type=template&id=e1809282"
import script from "./ConvexObjectPage.vue?vue&type=script&lang=js"
export * from "./ConvexObjectPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__